/* global Promise */

/** iOS 인앱 브라우저에서 Firebase SDK 에러나기 때문에 더미 클래스를 대신 사용 */
export class WebPushStub {
  constructor() {
    console.log('FCM NOT Supported');
  }

  requestPermission() {
    return Promise.resolve(false);
  }

  addMessageHandler(callback) {
    return () => {
      console.log(callback);
    };
  }

  hasSubscription() {
    return false;
  }

  registerSubscription(topic) {
    console.log(topic);
    return Promise.resolve(false);
  }

  unRegisterSubscription(topic) {
    console.log(topic);
    return Promise.resolve(false);
  }
}
